import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (state, action) => {
      state = action.payload;
      return state;
    },
  },
});
